module.exports = __webpack_public_path__ + "img/shrimp-and-grits.3550542f.jpg";